// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"GM-z","categoryName":"HM-z","categoryNameSearchHeader":"IM-z","categoryContent":"JM-z","bottomAligned":"KM-z","image":"LM-z","imageNoBackground":"MM-z"};